import React, { useState, useRef, useEffect } from 'react';
import Image from 'next/image';

const WhatsAppButton: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      buttonRef.current && !buttonRef.current.contains(event.target as Node) &&
      tooltipRef.current && !tooltipRef.current.contains(event.target as Node)
    ) {
      setIsHovered(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = () => {
    window.open(
      'https://wa.me/51980710030?text=Hola,%20necesito%20ayuda','_blank'
    );
  };

  return (
    <div className="whatsapp-button">
      <button
        ref={buttonRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
        className="whatsapp-icon"
      >
        <Image 
          src="/images/whatsapp-icon.png"
          alt="WhatsApp"
          width={64} 
          height={64}
          className="rounded-full"
        />
      </button>
      {isHovered && (
        <div ref={tooltipRef} className="whatsapp-button-tooltip">
          <p>Contáctanos por WhatsApp</p>
        </div>
      )}
    </div>
  );
};

export default WhatsAppButton;
